import { useHasScope, useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { CONTACTS_LISTS_ACCESS } from 'automation-ui-enrollment/constants/Scopes';
import { DEAL_OBJECT_LISTS } from 'automation-ui-enrollment/constants/Gates';
import { isObjectTypeIdAllowedForLists } from 'automation-ui-enrollment/constants/ObjectLists';
export const useGetHasListsToolAccess = () => {
  const isUngatedForDealObjectLists = useIsUngated(DEAL_OBJECT_LISTS);
  const hasListsAccessScope = useHasScope(CONTACTS_LISTS_ACCESS);
  return objectTypeId => hasListsAccessScope && isObjectTypeIdAllowedForLists(objectTypeId, {
    isUngatedForDealObjectLists
  });
};
const useHasListsToolAccess = objectTypeId => {
  return useGetHasListsToolAccess()(objectTypeId);
};
export default useHasListsToolAccess;